import { useSyncExternalStore } from "react";
import { getTheme, setTheme, subscribeTheme } from "../lib/theme.js";

/** Server snapshot: the boot script has not run, so dark is the default. */
const serverTheme = () => "dark" as const;

export function ThemeToggle() {
  const theme = useSyncExternalStore(subscribeTheme, getTheme, serverTheme);
  const next = theme === "dark" ? "light" : "dark";

  return (
    <button
      type="button"
      aria-pressed={theme === "light"}
      onClick={() => setTheme(next)}
      className="text-xs text-text-muted hover:text-text focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
    >
      Switch to {next}
    </button>
  );
}
